import { ChevronRight } from "lucide-react";
import { type ReactElement } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  count: number;
};

export function ConsentFooter({ count }: Props): ReactElement {
  const { t } = useTranslation();

  return (
    <footer className="consent-platform-footer">
      <span className="consent-platform-count" aria-live="polite">
        <strong>{count}</strong>
        {count > 1
          ? t("finalités activées sur 7")
          : t("finalité activée sur 7")}
      </span>
      <button
        type="submit"
        className="consent-platform-button consent-platform-button-primary"
      >
        <span>
          {t("Valider mes choix")}
          <small>{t("et accéder à mon espace")}</small>
        </span>
        <ChevronRight />
      </button>
    </footer>
  );
}
